import React from 'react';
export function Card({
  className = '',
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={`bg-white rounded-lg shadow ${className}`} data-id="element-188">{children}</div>;
}
export function CardContent({
  className = '',
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={`p-4 ${className}`} data-id="element-189">{children}</div>;
}